import 'reflect-metadata';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import vuetify from '@/plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';
import router from '@/plugins/router';
import containerBuilder from '@/plugins/containerBuilder';
import { register } from 'register-service-worker';
import { useEmitter, Events } from '@/plugins/emitter';
import VueGoodTablePlugin from 'vue-good-table-next';
import 'vue-good-table-next/dist/vue-good-table-next.css';

const params = new URLSearchParams(window.location.search);
const token = params.get('token');
containerBuilder({ token: token });
updateServiceWorkerManifest(token);

let app;
const eventbus = useEmitter();

if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
    let serviceWorker: ServiceWorker;

    register('/mpc/mpc-service-worker.js', {
        registered(reg) {
            serviceWorker = reg.active;

            if (serviceWorker) {
                App.created = function () {
                    eventbus.emitter.on(Events.updateServiceWorker, () => serviceWorker && serviceWorker.postMessage('SKIP_WAITING'));
                    eventbus.emitter.on(Events.online, () => serviceWorker && serviceWorker.postMessage('FLUSH_QUEUE'));
                };
                app = createApp(App).use(vuetify).use(router).use(createPinia()).use(VueGoodTablePlugin);

                app.mount('#app');
            } else {
                // Add / to the end of the URL accommodating query strings.
                const url = window.location.href.replace(/\/?(\?|#|$)/, '/$1');
                window.location.replace(url);
            }
        },
        updated(reg) {
            // update the local service worker reference to new SW
            serviceWorker = reg.waiting;

            if (app) {
                eventbus.emitter.emit(Events.serviceWorkerUpdated);
            }
        },
        error(error) {
            console.error('Error during service worker registration:', error);
        }
    });
} else {
    // for development mode
    app = createApp(App).use(vuetify).use(router).use(createPinia()).use(VueGoodTablePlugin);

    app.mount('#app');
}

function updateServiceWorkerManifest(token: string) {
    const url = `/mpc/mpc-manifest?token=${token}`;
    const el = document.querySelector('head > link[rel="manifest"]');
    el.setAttribute('href', url);
}
